import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=44df2133&scoped=true"
import script from "./CategoryDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=44df2133&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df2133",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44df2133')) {
      api.createRecord('44df2133', component.options)
    } else {
      api.reload('44df2133', component.options)
    }
    module.hot.accept("./CategoryDialog.vue?vue&type=template&id=44df2133&scoped=true", function () {
      api.rerender('44df2133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsCategory/components/CategoryDialog.vue"
export default component.exports